import { render, staticRenderFns } from "./HomeEn.vue?vue&type=template&id=5d97e792&scoped=true&"
import script from "./HomeEn.vue?vue&type=script&lang=js&"
export * from "./HomeEn.vue?vue&type=script&lang=js&"
import style0 from "./HomeEn.vue?vue&type=style&index=0&id=5d97e792&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97e792",
  null
  
)

export default component.exports